import { InjectedConnector } from '@web3-react/injected-connector';
import { WalletConnectConnector } from '@web3-react/walletconnect-connector';
import { WalletLinkConnector } from '@web3-react/walletlink-connector';

import { CHAIN_ID } from './web3Service';

const NETWORKS = {
  mainnet: 56,
  testnet: 97,
  ropsten: 3,
  kovan: 42,
  rinkeby: 4,
  goerli: 5,
  ethereum: 1,
};
const POLLING_INTERVAL = 12000;

const RPC_URL_56 = 'https://bsc-dataseed1.ninicoin.io/';
const RPC_URL_97 = 'https://data-seed-prebsc-1-s1.binance.org:8545';
const RPC_URL_1 = 'https://mainnet.infura.io/v3/920d962b397d4646989aa594147ba78c';

export const RPC_URLS = {
  1: RPC_URL_1,
  56: RPC_URL_56,
  97: RPC_URL_97,
};

export const injected = new InjectedConnector({
  supportedChainIds: [
    NETWORKS.mainnet,
    NETWORKS.testnet,
    NETWORKS.ropsten,
    NETWORKS.rinkeby,
    NETWORKS.goerli,
    NETWORKS.kovan,
    NETWORKS.ethereum,
  ],
});

export const walletlink = new WalletLinkConnector({
  url: RPC_URLS[97],
  appName: 'web3-react example',
});

export const walletconnect = new WalletConnectConnector({
  rpc: { [CHAIN_ID]: RPC_URLS[CHAIN_ID] },
  bridge: 'https://bridge.walletconnect.org',
  qrcode: true,
  pollingInterval: POLLING_INTERVAL,
});
